import {InMemoryCache} from '@apollo/client/cache'
import {ApolloLink, HttpLink} from '@apollo/client'
import {setContext} from '@apollo/client/link/context'
import {isAuthenticated} from '@cred/react-auth/utils'
import {getNewClient} from '../'
import getCookieLink from './cookie'
import fetch from '../../fetch'

function getSessionLink(cookies, options = {}) {
  const client = getNewClient({
    link: ApolloLink.from([
      getCookieLink(options),
      new HttpLink({uri: options.uri, credentials: 'same-origin', fetch})
    ]),
    cache: new InMemoryCache()
  })

  return setContext(async(req, {headers}) => {
    // Calling isAuthenticated refresh the token and set the authentication cookies properly
    await isAuthenticated(client, cookies)

    return {
      headers: {
        ...headers,
        'session-id': cookies.get('logSessionId')
      }
    }
  })
}

export default getSessionLink
